export const kindredMedia = {
  xs: { maxWidth: 479 },
  sm: { maxWidth: 639 },
  gtSm: { minWidth: 640 },
  md: { maxWidth: 767 },
  gtMd: { minWidth: 768 },
  lg: { maxWidth: 1023 },
  gtLg: { minWidth: 1024 },
  short: { maxHeight: 800 },
} as const;
